export default {
  default: {
    icon: "logo",
    nav2: "login",
    button: "helpBordered"
  },
  "/log-in": {
    icon: "logo",
    nav3: "createAccountText",
    button: "helpBordered"
  },
  "/forgot-password": {
    icon: "back",
    backUrl: "/log-in",
    h1: "forgotPassword",
    nav3: "createAccountText",
    button: "helpBordered"
  },
  "/forgot-password/confirmation-page": {
    icon: "back",
    backUrl: "/log-in",
    h1: "forgotPassword",
    nav3: "createAccountText",
    button: "helpBordered"
  },
  "/admin/reference": {
    icon: "logo",
    button: "helpBordered"
  },
  defaultMember: {
    icon: "logo",
    nav2: "memberProjects",
    nav3: "helpLinked",
    button: "memberSettings"
  },
  "/member/sign-up": {
    backgroundColor: "white",
    icon: "back",
    backUrl: "/log-in",
    h1: "createAccountBack",
    nav3: "login",
    button: "helpBordered"
  },
  "/member/complete-profile": {
    icon: "logo",
    nav2: "howItWorks",
    button: "helpBordered"
  },
  "/member/skills": {
    icon: "logo",
    nav2: "howItWorks",
    button: "helpBordered"
  },
  "/member/endorsements": {
    icon: "logo",
    nav1: "logout",
    nav2: "howItWorks",
    button: "helpBordered"
  },
  "/member/confirmation": {
    icon: "logo",
    nav2: "howItWorks",
    button: "helpBordered"
  },
  "/member/projects/matches/pitch-it/": {
    backgroundColor: "white",
    icon: "back",
    button: "helpBordered"
  },
  "/member/projects/": {
    icon: "logo",
    nav2: "memberProjects",
    nav3: "helpLinked",
    button: "memberSettings"
  },
  "/member/invoice/": {
    backgroundColor: "white",
    icon: "back",
    backUrl: "/member/projects/invoices",
    h1: "invoices",
    button: "helpBordered"
  },
  "/member/project/": {
    backgroundColor: "white",
    icon: "back",
    backUrl: "/member/projects/matches",
    h1: "matches",
    h2: "currentMatch",
    button: "helpBordered"
  },
  "/member/company/": {
    backgroundColor: "white",
    icon: "back",
    backUrl: "/member/projects/matches",
    h1: "memberEmployerProfile",
    button: "helpBordered"
  },
  defaultCompany: {
    icon: "logo",
    h1: "companyName",
    nav1: "companyProjects",
    nav2: "companyInvoices",
    nav3: "companySettings",
    nav4: "helpLinked"
  },
  "/company/home": {
    icon: "logo",
    h1: "companyName",
    nav2: "companySettings",
    nav3: "helpLinked"
  },
  "/company/sign-up": {
    backgroundColor: "white",
    icon: "back",
    backUrl: "/log-in",
    center: "step1of2",
    h1: "createEmployerAccount",
    nav2: "login",
    nav3: "howItWorks",
    button: "helpBordered"
  },
  "/company/create-company/": {
    icon: "logo",
    h1: "completeYourRegistration",
    center: "step2of2",
    nav3: "howItWorks",
    button: "helpBordered"
  },
  "/company/verify-account": {
    backgroundColor: "white",
    icon: "close",
    closeUrl: "/company/home",
    h1: "verifyAccount",
    button: "helpBordered"
  },
  "/company/project/create": {
    backgroundColor: "white",
    icon: "close",
    closeUrl: "/company/projects",
    h1: "submitNewProject",
    button: "helpBordered"
  },
  "/company/project/id/": {
    id: "header-project-return",
    backgroundColor: "white",
    icon: "close",
    closeUrl: "/company/projects",
    h1: "submitNewProject",
    button: "helpBordered"
  },
  "/company/projects": {
    icon: "logo",
    h1: "companyName",
    nav1: "companyProjects",
    nav2: "companyInvoices",
    nav3: "companySettings",
    nav4: "helpLinked",
    button: "newProjectButton"
  },
  "/company/invoices": {
    icon: "logo",
    h1: "companyName",
    nav1: "companyProjects",
    nav2: "companyInvoices",
    nav3: "companySettings",
    nav4: "helpLinked",
    button: "newProjectButton"
  },
  "company/account": {
    icon: "logo",
    h1: "companyName",
    nav1: "companyProjects",
    nav2: "companyInvoices",
    nav3: "companySettings",
    nav4: "helpLinked",
    button: "newProjectButton"
  },
  "/company/payment": {
    icon: "logo",
    h1: "companyName",
    nav1: "companyProjects",
    nav2: "companyInvoices",
    nav3: "companySettings",
    nav4: "helpLinked",
    button: "newProjectButton"
  },
  "/account/email/preferences": {
    icon: "logo",
    h1: "companyName",
    nav1: "companyProjects",
    nav2: "companyInvoices",
    nav3: "companySettings",
    nav4: "helpLinked",
    button: "newProjectButton"
  },
  "/company/project/": {
    backgroundColor: "white",
    icon: "back",
    backUrl: "/company/projects",
    h1: "allProjects",
    h2: "projectTitle2",
    nav3: "helpLinked",
    button: "projectSettings"
  },
  "/company/pitch/": {
    backgroundColor: "white",
    icon: "back",
    h1: "projectTitle1",
    h2: "candidateName",
    nav3: "helpLinked",
    button: "projectCandidateSettings"
  },
  defaultAdmin: {
    icon: "logo",
    nav1: "adminDashboard",
    nav2: "adminCompanies",
    nav3: "adminUsers",
    nav4: "adminProjects",
    nav5: "adminSettings",
    button: "adminMyAccount"
  },
  matchesTable: {
    backgroundColor: "white",
    icon: "back",
    backUrl: "adminProjectDetail",
    h1: "adminProject",
    h2: "adminProjectTitle"
  },
  "/admin/company/": {
    backgroundColor: "white",
    icon: "back",
    h1: "adminCompaniesTitle",
    button: "adminCompanySettings"
  },
  "/admin/company/*/billing": {
    regex: true,
    expression: /\/admin\/company\/\d*\/billing/,
    backgroundColor: "white",
    icon: "back",
    h1: "adminCompaniesTitleInvoice",
    button: "adminCompanySettings"
  },
  "/admin/invoice/*/": {
    regex: true,
    expression: /\/admin\/invoice\/\d*\//,
    backgroundColor: "white",
    icon: "back",
    h1: "adminCompaniesTitleInvoice"
  },
  "/admin/project/*/pitch/*/messages": {
    regex: true,
    expression: /\/admin\/project\/\d*\/pitch\/\d*\/messages/,
    backgroundColor: "white",
    icon: "back",
    backUrl: "adminProjectDetail",
    h1: "adminProject",
    h2: "adminProjectTitle",
    h3: "memberFullName",
    button: "adminProjectSettings"
  },
  "/admin/project/": {
    backgroundColor: "white",
    icon: "back",
    h1: "adminProject",
    h2: "adminProjectTitle",
    button: "adminProjectSettings"
  },
  "/admin/project/*/edit": {
    backgroundColor: "white",
    icon: "back",
    backUrl: "adminProjectDetail",
    h1: "adminProject",
    h2: "adminProjectTitle"
  },
  "/admin/member/approved/": {
    backgroundColor: "white",
    icon: "back",
    h1: "adminMember",
    h2: "adminMemberName",
    button: "adminMemberSettings"
  },
  "/admin/member/*/moderation/": {
    regex: true,
    expression: /\/admin\/member\/\d*\/moderation/,
    backgroundColor: "white",
    icon: "back",
    h1: "adminMember",
    h2: "adminMemberName",
    button: "adminMemberSettings"
  }
};



// WEBPACK FOOTER //
// ./src/routes/common/header/headers.js